/* The configurations used to enable/disable security feature on app
      ---> you can enable or disable any of the feature from here
*/
export const security = {
  enableTabEnforcerSecurity: false,
  showPasswordStrengthBar: true,
  allowedPasswordAttempts: 3, // handled from back end for now
};
